var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block paragraph-pic",class:{ odd: _vm.odd }},[_c('div',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.body)}}),_c('div',{staticClass:"media"},[_c('img',{attrs:{"src":_vm.media,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }